<template>
    <div>
        <h1>Billing</h1>
    </div>
</template>

<script>
    export default {
        name: 'Billing'
    };
</script>
